<script>
import VueTypes from 'vue-types'
import Question from './Question.vue'
import { CollapseTransition } from 'vue2-transitions'

export default {
  name: 'FaqItem',

  components: {
    CollapseTransition,
    Question
  },

  props: {
    index: VueTypes.string.def('')
  },

  methods: {
    isActiveIndex(index) {
      return this.$attrs.activeindex === index
    },
    updateActiveCategory(index) {
      this.$emit('update-active', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  border: 1px solid rgb(177, 177, 177);

  + .item {
    border-top: none;
  }

  &__title {
    padding: 15px;
    cursor: pointer;

    img {
      max-width: 40px;
    }

    span {
      padding-left: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &__content {
    padding: 0 15px 15px;

    h6 {
      display: inline-block;
      margin-bottom: 10px;
    }

    .o-grid__col {
      + .o-grid__col {
        h6 {
          margin-top: 20px;

          @include iota-breakpoint(lg) {
            margin-top: 0;
          }
        }
      }

      @include iota-breakpoint(lg) {
        &:nth-child(n + 3) {
          margin-top: 25px;
        }
      }

      @include iota-breakpoint(xl) {
        &:nth-child(3) {
          margin-top: 0;
        }

        &:nth-child(n + 4) {
          margin-top: 25px;
        }
      }
    }

    @include iota-breakpoint(md) {
      border: 1px solid rgb(177, 177, 177);
      transition: none !important;
    }
  }

  @include iota-breakpoint(md) {
    border: none;
  }
}
</style>
